import gsap from 'gsap';
import { useElementOption } from './useElementOption.mjs';
import { setTriangleAttr, disposeMainAxis, disposeSubAxis } from '../utils.mjs';
import '../../../utility/index.mjs';
import setting from '../setting.mjs';
import { isNumber } from 'lodash-es';

const relativeContainerBody = (nodes, option) => {
  const data = relativeContainerBodySite(nodes, option);
  if (option.animation) {
    gsap.to(nodes.view, { top: data.offsetY, left: data.offsetX, duration: 0.2 });
  } else {
    nodes.view.style.transformOrigin = `${setting.DIRECTION[data.direction]} center`;
    nodes.view.style.left = `${data.offsetX}px`;
    nodes.view.style.top = `${data.offsetY}px`;
  }
  if (nodes.triangle) {
    setTriangleAttr(nodes.triangle, data.direction, data.align);
  }
};
const relativeContainerBodySite = (nodes, option) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
  const rect = useElementOption(nodes.container);
  const offsetYMin = ((_b = (_a = option.boundary) == null ? void 0 : _a.y) == null ? void 0 : _b.min) || 0;
  const offsetYMax = ((_d = (_c = option.boundary) == null ? void 0 : _c.y) == null ? void 0 : _d.max) || innerHeight;
  const offsetXMin = ((_f = (_e = option.boundary) == null ? void 0 : _e.x) == null ? void 0 : _f.min) || 0;
  const offsetXMax = ((_h = (_g = option.boundary) == null ? void 0 : _g.x) == null ? void 0 : _h.max) || innerWidth;
  if (option.height) nodes.view.style.maxHeight = option.height + "px";
  if (option.width) {
    if (isNumber(option.width)) {
      nodes.view.style.width = option.width + "px";
      nodes.view.style.minWidth = "";
      nodes.view.style.maxWidth = "";
    } else {
      if (option.width.min) nodes.view.style.minWidth = option.width.min + "px";
      else {
        nodes.view.style.minWidth = "";
      }
      if (option.width.max) nodes.view.style.maxWidth = option.width.max + "px";
      else {
        nodes.view.style.maxWidth = "";
      }
    }
  }
  switch (option.direction) {
    case "top": {
      const offest = { offsetX: rect.rootX, offsetY: Math.floor(rect.rootY - option.offset - nodes.view.offsetHeight) };
      const mainAxis = disposeMainAxis(
        { container: rect.height, space: option.offset, view: nodes.view.offsetHeight },
        {
          min: offsetYMin + scrollY,
          max: offsetYMax + scrollY,
          offset: offest.offsetY,
          strategy: (_i = option.boundary) == null ? void 0 : _i.strategy,
          direction: option.direction,
          orientation: -1
        }
      );
      const subAxis = disposeSubAxis(
        { container: rect.width, space: 0, view: nodes.view.offsetWidth },
        {
          min: offsetXMin + scrollX,
          max: offsetXMax + scrollX,
          align: option.align,
          offset: offest.offsetX,
          strategy: (_j = option.boundary) == null ? void 0 : _j.strategy
        }
      );
      return { offsetY: mainAxis.offset, offsetX: subAxis.offset, align: subAxis.align, direction: mainAxis.direction };
    }
    case "left": {
      const offest = { offsetX: Math.floor(rect.rootX - option.offset - nodes.view.offsetWidth), offsetY: rect.rootY };
      const mainAxis = disposeMainAxis(
        { container: rect.width, space: option.offset, view: nodes.view.offsetWidth },
        {
          min: offsetXMin + scrollX,
          max: offsetXMax + scrollX,
          offset: offest.offsetX,
          strategy: (_k = option.boundary) == null ? void 0 : _k.strategy,
          direction: option.direction,
          orientation: -1
        }
      );
      const subAxis = disposeSubAxis(
        { container: rect.height, space: 0, view: nodes.view.offsetHeight },
        {
          min: offsetYMin + scrollY,
          max: offsetYMax + scrollY,
          align: option.align,
          offset: offest.offsetY,
          strategy: (_l = option.boundary) == null ? void 0 : _l.strategy
        }
      );
      return { offsetY: subAxis.offset, offsetX: mainAxis.offset, align: subAxis.align, direction: mainAxis.direction };
    }
    case "right": {
      const offest = { offsetX: Math.floor(rect.rootX + rect.width + option.offset), offsetY: rect.rootY };
      const mainAxis = disposeMainAxis(
        { container: rect.width, space: option.offset, view: nodes.view.offsetWidth },
        {
          min: offsetXMin + scrollX,
          max: offsetXMax + scrollX,
          offset: offest.offsetX,
          strategy: (_m = option.boundary) == null ? void 0 : _m.strategy,
          direction: option.direction,
          orientation: 1
        }
      );
      const subAxis = disposeSubAxis(
        { container: rect.height, space: 0, view: nodes.view.offsetHeight },
        {
          min: offsetYMin + scrollY,
          max: offsetYMax + scrollY,
          align: option.align,
          offset: offest.offsetY,
          strategy: (_n = option.boundary) == null ? void 0 : _n.strategy
        }
      );
      return { offsetY: subAxis.offset, offsetX: mainAxis.offset, align: subAxis.align, direction: mainAxis.direction };
    }
    case "bottom": {
      const offest = { offsetX: rect.rootX, offsetY: Math.floor(rect.rootY + rect.height + option.offset) };
      const mainAxis = disposeMainAxis(
        { container: rect.height, space: option.offset, view: nodes.view.offsetHeight },
        {
          min: offsetYMin + scrollY,
          max: offsetYMax + scrollY,
          offset: offest.offsetY,
          strategy: (_o = option.boundary) == null ? void 0 : _o.strategy,
          direction: option.direction,
          orientation: 1
        }
      );
      const subAxis = disposeSubAxis(
        { container: rect.width, space: 0, view: nodes.view.offsetWidth },
        {
          min: offsetXMin + scrollX,
          max: offsetXMax + scrollX,
          align: option.align,
          offset: offest.offsetX,
          strategy: (_p = option.boundary) == null ? void 0 : _p.strategy
        }
      );
      return { offsetY: mainAxis.offset, offsetX: subAxis.offset, align: subAxis.align, direction: mainAxis.direction };
    }
    default: {
      return { offsetY: 0, offsetX: 0, align: option.align, direction: "top" };
    }
  }
};

export { relativeContainerBody, relativeContainerBodySite };
//# sourceMappingURL=relativeContainerBody.mjs.map
